export default __webpack_public_path__ + "static/media/pic2.055d9d15.jpg";